import React, { useState, useEffect } from 'react';

export default function AppHeader({ onNavigate, onBack, backLabel, large, toggleText, t, isRTL, lang, switchLang, onDiagnostic }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handle = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handle);
    return () => window.removeEventListener('resize', handle);
  }, []);

  const T = t || {};
  const nav = T.nav || {};
  const burger = T.burger || {};
  const moduleNames = T.moduleNames || {};

  const LANGS = [
    { code: 'fr', label: 'FR', flag: '🇫🇷', color: '#003189' },
    { code: 'en', label: 'EN', flag: '🇬🇧', color: '#C8102E' },
    { code: 'it', label: 'IT', flag: '🇮🇹', color: '#009246' },
    { code: 'es', label: 'ES', flag: '🇪🇸', color: '#AA151B' },
    { code: 'zh', label: '中', flag: '🇨🇳', color: '#DE2910' },
    { code: 'ar', label: 'ع',  flag: '🇸🇦', color: '#007A3D' },
    { code: 'pt', label: 'PT', flag: '🇵🇹', color: '#006600' },
  ];

  const MODULES_MENU = [
    { icon: '📬', id: 'courrier' }, { icon: '📄', id: 'pdf' },
    { icon: '✉️', id: 'email' }, { icon: '📁', id: 'dossier' },
    { icon: '🔒', id: 'securite' }, { icon: '🧾', id: 'impots' },
    { icon: '💊', id: 'cartevitale' }, { icon: '🏛️', id: 'rsacaf' },
    { icon: '🏠', id: 'logement' }, { icon: '🏥', id: 'dossiermedical' },
    { icon: '🎓', id: 'formation' }, { icon: '🚗', id: 'permis' },
    { icon: '🏦', id: 'banque' }, { icon: '📱', id: 'smartphone' },
  ];

  return (
    <div style={{ position: 'sticky', top: 0, zIndex: 100 }}>
    <header style={{
      background: '#003189',
      borderBottom: isMobile ? 'none' : '3px solid #0063CB',
      padding: '0 1rem', height: isMobile ? 52 : 64,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      direction: isRTL ? 'rtl' : 'ltr',
      boxSizing: 'border-box', width: '100%',
      boxShadow: isMobile ? 'none' : '0 2px 8px rgba(0,49,137,0.2)',
    }}>

      {/* GAUCHE */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, zIndex: 1 }}>
        {onBack && (
          <button onClick={onBack} style={{
            background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)',
            color: '#fff', fontSize: 13, fontWeight: 600,
            padding: '6px 14px', borderRadius: 8, cursor: 'pointer',
          }}>
            {isRTL ? `${backLabel || nav.back} →` : `← ${backLabel || nav.back}`}
          </button>
        )}
      </div>

      {/* CENTRE — Nom du site */}
      <div onClick={() => onNavigate('home')} style={{
        fontFamily: 'Fraunces, serif',
        fontSize: isMobile ? 20 : 36,
        fontWeight: 700, color: '#fff', cursor: 'pointer',
        letterSpacing: '-0.5px', whiteSpace: 'nowrap',
        position: 'absolute', left: '50%', transform: 'translateX(-50%)',
      }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
          Démarches<span style={{ color: '#8DB4FF' }}>Claires</span>
          <span style={{
            display: 'inline-flex', alignItems: 'center', gap: 4,
            fontSize: isMobile ? 9 : 11,
            fontWeight: 700,
            color: 'rgba(255,255,255,0.75)',
            letterSpacing: '0.06em',
            fontFamily: 'DM Sans, sans-serif',
          }}>
            <span style={{
              width: isMobile ? 6 : 7,
              height: isMobile ? 6 : 7,
              borderRadius: '50%',
              background: '#4ADE80',
              display: 'inline-block',
              boxShadow: '0 0 0 0 rgba(74,222,128,0.7)',
              animation: 'pulse-ia 2s infinite',
              flexShrink: 0,
            }} />
            IA
          </span>
        </span>
      </div>

      {/* DROITE */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, zIndex: 1 }}>

        {/* ── LANGUES DESKTOP ── */}
        {!isMobile && switchLang && (
          <div style={{ display: 'flex', gap: 3 }}>
            {LANGS.map(({ code, label, color }) => (
              <button key={code} onClick={() => switchLang(code)} style={{
                background: lang === code ? '#fff' : 'rgba(255,255,255,0.12)',
                border: `1.5px solid ${lang === code ? '#fff' : 'rgba(255,255,255,0.25)'}`,
                color: lang === code ? '#003189' : '#fff',
                borderRadius: 6, padding: '4px 9px',
                fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer',
                opacity: lang === code ? 1 : 0.8,
                transition: 'all 0.15s ease',
                fontFamily: 'DM Sans, system-ui, sans-serif',
                letterSpacing: '0.03em',
              }}>
                {label}
              </button>
            ))}
          </div>
        )}



        {/* A+ desktop */}
        {!isMobile && toggleText && (
          <button onClick={toggleText} style={{
            width: 38, height: 38, borderRadius: 8,
            background: large ? '#fff' : 'rgba(255,255,255,0.12)',
            border: `1.5px solid ${large ? '#fff' : 'rgba(255,255,255,0.25)'}`,
            color: large ? '#003189' : '#fff',
            fontSize: 13, fontWeight: 700, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>A+</button>
        )}

        {/* Burger */}
        <div style={{ position: 'relative' }}>
          <button onClick={() => setMenuOpen(!menuOpen)} style={{
            width: 38, height: 38, borderRadius: 8,
            background: menuOpen ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.15)',
            border: '1.5px solid rgba(255,255,255,0.3)',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            gap: 5, cursor: 'pointer', padding: 0,
            transition: 'background 0.15s ease',
          }}>
            {[0,1,2].map(i => (
              <span key={i} style={{ width: 18, height: 2.5, borderRadius: 2, background: '#fff', display: 'block' }} />
            ))}
          </button>

          {menuOpen && (
            <>
              {/* Overlay */}
              <div onClick={() => setMenuOpen(false)} style={{
                position: 'fixed', inset: 0, zIndex: 199,
                background: 'rgba(0,0,0,0.3)',
              }} />

              {/* Menu panel */}
              <div style={{
                position: 'fixed',
                top: isMobile ? 56 : 64,
                [isRTL ? 'left' : 'right']: isMobile ? 0 : 16,
                left: isMobile ? 0 : 'auto',
                background: '#fff', borderRadius: isMobile ? '0 0 16px 16px' : 16,
                boxShadow: '0 8px 32px rgba(0,49,137,0.15)',
                minWidth: isMobile ? '100vw' : 260,
                zIndex: 200, overflow: 'hidden',
                maxHeight: '80vh', overflowY: 'auto',
                direction: isRTL ? 'rtl' : 'ltr',
              }}>

                {/* A+ mobile dans le burger */}
                {isMobile && toggleText && (
                  <>
                    <button onClick={() => { toggleText(); setMenuOpen(false); }}
                      style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 18px', cursor: 'pointer', fontSize: 14, fontWeight: 500, color: '#333', background: 'none', border: 'none', width: '100%', textAlign: 'left' }}>
                      🔤 {nav.textLarger || 'Texte plus grand'}
                    </button>
                    <div style={{ borderTop: '1px solid #F0F0F0' }} />
                  </>
                )}

                {/* Navigation */}
                <div style={{ fontSize: 11, fontWeight: 700, color: '#888', letterSpacing: 1.5, textTransform: 'uppercase', padding: '12px 18px 4px' }}>
                  {burger.navigation || 'Navigation'}
                </div>
                {[
                  { label: `🏠 ${nav.home || 'Accueil'}`, target: 'home' },
                  { label: `🧭 ${t?.nav?.guide || 'Guide'}`, target: 'onboarding' },
                  { label: `💡 ${nav.jeexplique || 'Comment ça marche'}`, target: 'jeexplique' },
                ].map(item => (
                  <button key={item.target}
                    onClick={() => { onNavigate(item.target); setMenuOpen(false); }}
                    style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 18px', cursor: 'pointer', fontSize: 14, fontWeight: 500, color: '#333', background: 'none', border: 'none', width: '100%', textAlign: isRTL ? 'right' : 'left' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#F5F5FE'}
                    onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                    {item.label}
                  </button>
                ))}

                <div style={{ borderTop: '1px solid #F0F0F0' }} />

                {/* Modules */}
                <div style={{ fontSize: 11, fontWeight: 700, color: '#888', letterSpacing: 1.5, textTransform: 'uppercase', padding: '10px 18px 4px' }}>
                  {burger.modules || 'Modules'}
                </div>
                {MODULES_MENU.map(item => (
                  <button key={item.id}
                    onClick={() => { onNavigate('module', item.id); setMenuOpen(false); }}
                    style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 18px', cursor: 'pointer', fontSize: 14, fontWeight: 500, color: '#333', background: 'none', border: 'none', width: '100%', textAlign: isRTL ? 'right' : 'left' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#F5F5FE'}
                    onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                    {item.icon} {moduleNames[item.id] || item.id}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </header>

    {/* ── BARRE LANGUES MOBILE — sous le header ── */}
    {isMobile && switchLang && (
      <div style={{
        background: '#002070',
        borderBottom: '2px solid #0063CB',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4,
        padding: '6px 12px',
        boxShadow: '0 2px 8px rgba(0,49,137,0.2)',
        direction: 'ltr',
        overflowX: 'auto',
        flexWrap: 'nowrap',
      }}>
        {LANGS.map(({ code, flag, label }) => (
          <button
            key={code}
            onClick={() => switchLang(code)}
            style={{
              background: lang === code ? 'rgba(255,255,255,0.2)' : 'transparent',
              border: lang === code ? '1.5px solid rgba(255,255,255,0.55)' : '1.5px solid transparent',
              borderRadius: 8,
              padding: '3px 6px',
              fontSize: 20,
              cursor: 'pointer',
              lineHeight: 1,
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1,
              flexShrink: 0,
              transition: 'all 0.15s ease',
            }}
            title={label}
          >
            <span style={{ fontSize: 18 }}>{flag}</span>
            <span style={{ fontSize: 9, color: lang === code ? '#fff' : 'rgba(255,255,255,0.55)', fontWeight: 700, letterSpacing: '0.03em' }}>
              {label}
            </span>
          </button>
        ))}
      </div>
    )}
    </div>
  );
}
